import styled from 'styled-components';
import { Valence } from '../../../../../../../../../common/model/types';
import { useImpactChartContext, useImpactChartHeights, useImpactChartWidths } from '../../context';
import { grayBorder } from '../../shared';
import { DimensionRowBar } from './bar';
import { DimensionRowLeftPart } from './left-part';
import { DimensionRowMiddlePart } from './middle-part';
import { DimensionRowProps } from './types';

export function DimensionRow(props: DimensionRowProps) {
  const { desktopMode, setExpanded, isExpanded, alignLineEdges, simplify } = useImpactChartContext();
  const heights = useImpactChartHeights();
  const widths = useImpactChartWidths();

  const linePadding = alignLineEdges ? 0 : widths.commonHorizontalPadding;
  const lineWidth = alignLineEdges ? widths.full : widths.full - linePadding * 2;

  const expanded = isExpanded(props.dimension);
  const height = expanded ? heights.dimensionRowExpanded : heights.dimensionRow;

  return (
    <Root
      onClick={() => {
        setExpanded(props.dimension, !expanded);
      }}
    >
      <>
        <rect x={0} y={0} width={widths.full} height={height} fill="transparent" />
        <line x1={linePadding} x2={lineWidth} y1={1} y2={1} stroke={grayBorder} strokeWidth={1} />
      </>
      <DimensionRowLeftPart {...props} />
      {simplify ? undefined : <DimensionRowMiddlePart {...props} />}
      {desktopMode && (
        <>
          <DimensionRowBar {...props} valence={Valence.NEGATIVE} />
          <DimensionRowBar {...props} valence={Valence.POSITIVE} />
        </>
      )}
    </Root>
  );
}

const Root = styled.g`
  cursor: pointer;
`;
